import { Component, ElementRef, OnInit } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ConfirmLogoutDialogService } from './confirm-logout-dialog.service';
import { PERIODS } from 'src/util/constant';

@Component({
  selector: 'app-confirm-logout-dialog',
  templateUrl: './confirm-logout-dialog.component.html',
  styleUrls: ['./confirm-logout-dialog.component.css'],
})
export class ConfirmLogoutDialogComponent implements OnInit {

  public confirmDialogState: boolean = false;
  public args: any = null;

  private counter: number = PERIODS.MINUTE;
  private counterTimeOut: any = null;

  constructor(public dialogService: ConfirmLogoutDialogService, public componentElement: ElementRef) { }

  ngOnInit(): void {

    // reposition page loader
    const confirmDialog = this.componentElement.nativeElement.querySelector("div");
    document.body.appendChild(confirmDialog);

    //
    // listen for page loader change
    this.dialogService.confirmLogout.subscribe((args: any) => {
      this.args = args;

      // 
      if (this.counterTimeOut)
        clearTimeout(this.counterTimeOut);

      this.counter = PERIODS.MINUTE;
      document.getElementById("counter-span").innerHTML = (this.counter / PERIODS.SECOND).toString();

      // 
      this.setCounter();
    });
  }

  setCounter() {
    if (this.counterTimeOut)
      clearTimeout(this.counterTimeOut);

    this.counterTimeOut = setTimeout(() => {
      this.counter -= PERIODS.SECOND;
      document.getElementById("counter-span").innerHTML = (this.counter / PERIODS.SECOND).toString();
      this.setCounter();

      if (this.counter < PERIODS.SECOND) {
        this.counter = PERIODS.MINUTE;
        this.dialogService.hide();
        this.args?.logout();

        if (this.counterTimeOut)
          clearTimeout(this.counterTimeOut);
      }
    }, PERIODS.SECOND);
  }

  confirm(evt: any) {
    if (this.args?.okay)
      this.args?.okay(this.args?.data);

    if (this.counterTimeOut)
      clearTimeout(this.counterTimeOut);

    this.dialogService.hide();
  }

  close(evt: any) {
    if (this.args?.logout)
      this.args?.logout();

    this.dialogService.hide();
  }
}
